import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { API_AUTH_SKIP_TRANSACTION_URL } from "constants/apiUrls";

import { AuthTransaction } from "../types/authTransaction";
import { OktaError } from "../../../types/oktaError/oktaError";

import useAuthTransactionApiClient from "./useAuthTransactionApiClient";

function useSkipMfaEnrollment(): UseMutationResult<
  AuthTransaction,
  OktaError,
  { stateToken: string }
> {
  const authTransactionApiClient = useAuthTransactionApiClient();

  return useMutation({
    mutationFn: async ({ stateToken }) => {
      const response = await authTransactionApiClient(
        API_AUTH_SKIP_TRANSACTION_URL,
        {
          method: "POST",
          body: JSON.stringify({ stateToken }),
        },
      );

      const data = await response.json();
      return response.ok ? Promise.resolve(data) : Promise.reject(data);
    },
  });
}

export default useSkipMfaEnrollment;
